export enum ESettingsPaths {
  Base = "settings",
  TenantProfile = "tenant-profile",
  TenantProfileNotifications = "tenant-profile-notifications",
  TemplatePreferences = "template-preferences",
  Communication = "communication",
}
